import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4818b1bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4818b1bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818b1bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/foryor-newMarketing_JSiZ/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4818b1bc')) {
      api.createRecord('4818b1bc', component.options)
    } else {
      api.reload('4818b1bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4818b1bc&scoped=true", function () {
      api.rerender('4818b1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/SvgIcon/index.vue"
export default component.exports